// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"230":"cd6b5c1b","403":"7c139522","514":"632acf75","594":"d5cb338f","835":"dd1beef7","849":"9bad4df6","882":"2a7f3343","985":"2bacb2dc"}[chunkId] + ".js";
};